import { WorkbenchNotesConfigComponent, WorkbenchDecisionConfigComponent } from "@AccountConfig/account-settings/workbench-settings";
import { Component, ViewEncapsulation, Input } from "@angular/core";
import { Client, Account } from "@Models";
import { SharedModule } from "@Shared/shared.module";
import WorkbenchV2AutomatedMappingConfigComponent from "./workbenchv2-automated-mapping-config.component";
import WorkbenchV2TaskOptionsComponent from "./workbenchv2-task-options.component";
import WorkbenchV2SuppressIntegrationsConfigComponent from "../workbenchv2-suppress-integrations-config.component";

@Component({
    selector: 'workbenchv2-options-config',
    templateUrl: './workbenchv2-options-config.component.html',
    styleUrls: ['./workbenchv2-options-config.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [SharedModule, WorkbenchNotesConfigComponent, WorkbenchDecisionConfigComponent, WorkbenchV2AutomatedMappingConfigComponent, WorkbenchV2SuppressIntegrationsConfigComponent, WorkbenchV2TaskOptionsComponent]
})

export default class WorkbenchV2OptionsConfigComponent {
    @Input() client: Client;
    @Input() account: Account;
}
